import { Etapa } from "./etapa/etapa";
import { Base } from "../core/base.model";
import { Empleado } from "../empleado/empleado.model";
import { EvidenciaOportunidad } from "./evidenciasOportunidad";
import { comentariosOportunidad } from "src/app/proceso-operativo/modelos/comentariosOportunidad.model";
import { nuevosAlcances } from "./nuevosAlcances";
import { comentariosAvances } from "./comentariosAvances";
import { ProductoCliente } from "./productoCliente";
import { IntegranteLiberado } from "./integrante-liberado";

export class Proyecto extends Base {
  /** El _id del documento en Mongo (texto). */
  id: string;

  nombre: string;

  idCliente: number;
  razonSocial: string;

  porcentPlaneado: number;
  porcentReal: number;

  estatus: string;
  idLider: number;
  nombreLider: string;
  fechaCreacion: string;
  fecha_creacion: Date;
  fechaActualizacion: string;
  fechaInicio: Date;
  fechaFin: Date;
  fechaFinProyReal: Date;
  fechaIniProyReal: Date;
  nomArea: string;

  numeroRecursos: number;
  horasTotales: number;
  horasTotalesReales: number;
  horaFin: string;
  mesesEstimados: number;
  condicionamb: string;

  nombre_corto: string;
  descripcion: string;
  etapas: Etapa[] = [];
  colaboradores: Empleado[] = [];
  idArea: number;
  nombreArea: string;
  descripcionProy;
  color: string;
  horasTotl: string;
  id_lider: number;
  presupuestoAutorizado: number;
  horasEtc: number;
  presupuestoGastado: number;
  porcentajeAvance: number;
  avancePlaneado: number;
  avanceReal: number;
  comentarios: comentariosOportunidad[] = [];
  clave: string;
  requerimiento: string;
  tipo: string;
  observaciones: string;
  aplicacion: string;


  //Agregar variables para insersion de oportunidades
  grupo: string;
  fechaEstimacion: string;
  archivos: EvidenciaOportunidad[] = [];
  nombreCliente: string;
  idGit: number;
  checkvalidacion: boolean;
  idPadre: number;
  estado: string;
  username: string;
  name: string;
  idUser: number;
  semaforo: string = "btn-yellow";
  correoMarketing: String;

  riesgoSeveridad: string[];
  riesgoCantidad: number[];
  id_tipoServicio: number;
  tipoServicio: string;
  nuevosAlcances: nuevosAlcances[] = [];
  idProyecto: string;
  usuarioLider: number;
  comentariosAvances: comentariosAvances[] = [];
  ultimoNumeroUtilizado: number;

  existenRiesgos: boolean;
  producto: number;
  servicio: number;
  tipoVobo: string;

  total_riesgos: number;
  total_defectos: number;

  /** Proyecto de Azure DevOps ligado (id GUID y nombre); vacío si no está ligado. */
  idProyectoAzure: string;
  nombreProyectoAzure: string;
  /** Historial de integrantes que salieron del proyecto; lo administra el backend. */
  integrantesLiberados: IntegranteLiberado[];
}
